const steps = {
  form: {
    titleLong: 'Form und Maße',
    titleShort: 'Form',
    id: 1
  },
  material: {
    titleLong: 'Material und Farbe',
    titleShort: 'Material',
    id: 2
  },
  rand: {
    titleLong: 'Randgestaltung',
    titleShort: 'Rand',
    id: 3
  }
}

export default {
  steps
}
